export default __webpack_public_path__ + "recentMeetingRooms.json";